// Strips the query string and fragment so the same page counted under different tracking
// parameters collapses to one entry. Shared by the Sources panorama and the per-card popup
// so both views agree on what counts as a distinct page.
export function normalizeUrl(url) {
  try {
    const u = new URL(url)
    u.search = ''
    u.hash = ''
    return u.toString()
  } catch { return url }
}

export function normalizeReport(report) {
  if (report.llm_results) return report;

  if (!report.results || typeof report.results !== 'object') return report;

  const llm_results = Object.entries(report.results).map(([providerName, categories]) => ({
    llm_name: providerName,
    categories: Object.fromEntries(
      Object.entries(categories).map(([cat, data]) => [
        cat,
        {
          score: data.score ?? 0,
          questions: data.questions ?? [],
          // New format fields
          web_on_pros: data.web_on_pros ?? null,
          web_on_cons: data.web_on_cons ?? null,
          web_off_pros: data.web_off_pros ?? null,
          web_off_cons: data.web_off_cons ?? null,
          web_on_urls: data.web_on_urls ?? {},
          web_on_pros_cons_error: data.web_on_pros_cons_error ?? null,
          web_off_pros_cons_error: data.web_off_pros_cons_error ?? null,
          // Legacy fields kept for backwards compatibility
          web_on_synthetic: data.web_on_synthetic ?? null,
          web_on_critical: data.web_on_critical ?? null,
          web_off_synthetic: data.web_off_synthetic ?? null,
          web_off_critical: data.web_off_critical ?? null,
        }
      ])
    )
  }));

  return {
    ...report,
    llm_results,
    generated_at: report.generated_at ?? report.date ?? null,
  };
}
